import _define_property from "@swc/helpers/src/_define_property.mjs";
import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_spread_props from "@swc/helpers/src/_object_spread_props.mjs";
import { createAction, handleActions } from "redux-actions";
export var actionTypes = {
    ZENDESK_SCRIPT_LOAD: "zendesk/script/load",
    ZENDESK_SCRIPT_LOADED: "zendesk/script/loaded",
    ZENDESK_SCRIPT_LOADED_AND_DELAYED: "zendesk/script/loaded_and_delayed",
    WIDGET_OPENED: "zendesk/widget/opened",
    WIDGET_CLOSED: "zendesk/widget/closed"
};
export var actions = {
    loadZendeskScript: createAction(actionTypes.ZENDESK_SCRIPT_LOAD),
    zendeskScriptLoaded: createAction(actionTypes.ZENDESK_SCRIPT_LOADED),
    zendeskScriptLoadedAndDelayed: createAction(actionTypes.ZENDESK_SCRIPT_LOADED_AND_DELAYED),
    widgetOpened: createAction(actionTypes.WIDGET_OPENED),
    widgetClosed: createAction(actionTypes.WIDGET_CLOSED)
};
var initialState = {
    hasZendeskScriptLoaded: false,
    hasZendeskScriptLoadedAndDelayed: false,
    isWidgetOpen: false
};
var _obj;
export var reducer = handleActions((_obj = {}, _define_property(_obj, actionTypes.ZENDESK_SCRIPT_LOADED, function(state) {
    return _object_spread_props(_object_spread({}, state), {
        hasZendeskScriptLoaded: true
    });
}), _define_property(_obj, actionTypes.ZENDESK_SCRIPT_LOADED_AND_DELAYED, function(state) {
    return _object_spread_props(_object_spread({}, state), {
        hasZendeskScriptLoadedAndDelayed: true
    });
}), _define_property(_obj, actionTypes.WIDGET_OPENED, function(state) {
    return _object_spread_props(_object_spread({}, state), {
        isWidgetOpen: true
    });
}), _define_property(_obj, actionTypes.WIDGET_CLOSED, function(state) {
    return _object_spread_props(_object_spread({}, state), {
        isWidgetOpen: false
    });
}), _obj), initialState);
export var selectors = {
    hasZendeskScriptLoaded: function(state) {
        return state.zendesk.hasZendeskScriptLoaded;
    },
    hasZendeskScriptLoadedAndDelayed: function(state) {
        return state.zendesk.hasZendeskScriptLoadedAndDelayed;
    },
    isWidgetOpen: function(state) {
        return state.zendesk.isWidgetOpen;
    }
};
